import React, { Component } from "react";
import "./styles/app.css";
import { Route } from "react-router-dom";
import { Provider } from "react-redux";
import "date-input-polyfill";
import { ConnectedRouter } from "react-router-redux";
import createStore, { history } from "./store";
import "./i18n";
import * as ROUTES from "./routes";
import ServiceProvider from "./providers/ServiceProvider";
import FeathersService from "./services/FeathersService";
import * as Views from "./components/views";
import PrintProvider from "react-easy-print";
const store = createStore();
const services = {
  feathers: FeathersService
};

class App extends Component {
  render() {
    return (
      <PrintProvider>
        <Views.ErrorView>
          <Provider store={store}>
            <ConnectedRouter history={history}>
              <ServiceProvider services={services}>
                <Route path={ROUTES.ROOT} component={Views.RootView} />
              </ServiceProvider>
            </ConnectedRouter>
          </Provider>
        </Views.ErrorView>
      </PrintProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx